<script setup>
defineProps(['optionName', 'categoryName'])
defineEmits(['removeFilter'])

const appConfig = useAppConfig()
</script>

<template>
  <div class="border-2 border-med-deep-navy bg-med-light-aqua font-medium rounded-full py-1 px-2 m-1">
    <span class="mr-1">
      {{ optionName.name }}
    </span>
    <button
      class="align-sub"
      :aria-label="`Remove filter on ${optionName.name}`"
      @click="$emit('removeFilter', categoryName, optionName.urlName)"
    >
      <UIcon
        :name="appConfig.ui.icons.close"
        class="size-4"
        aria-hidden="true"
      />
    </button>
  </div>
</template>
